export default __webpack_public_path__ + "static/media/policy14_2023.e484d913.jpg";